import styled from 'styled-components';

export const FullWidthContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
`;
